/**
 * @summary
 * <blockquote>Creates a standardized NextResponse for external errors with appropriate HTTP status codes</blockquote>
 **/
import { NextResponse } from 'next/server';
import { analyzeNetworkError } from './analyzeNetworkError';
import { getStatusCodeForErrorType } from './getStatusCodeForErrorType';
import type { NetworkErrorOptions } from '../types/NetworkErrorOptions';
import type { NetworkErrorResponse } from '../types/NetworkErrorResponse';

export function handleNetworkError(
  error: any,
  operation: string = 'external operation',
  options: NetworkErrorOptions = {}
): NextResponse<NetworkErrorResponse> {
  const errorResponse = analyzeNetworkError(error, { ...options, operation });
  const statusCode = getStatusCodeForErrorType(errorResponse.type);
  
  // Log error for monitoring (in production, this should use @shared/logger)
  console.error(`External error during ${operation}:`, {
    error: errorResponse,
    originalError: error
  });

  return NextResponse.json(errorResponse, { status: statusCode });
} 